module.exports = {
	"id": "wdwd.items.onsale.get",
	"description": "获取在售商品列表",
	"meta": {
		"oauth": true
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.items.onsale.get",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.items.onsale.get"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.items.onsale.get",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.items.onsale.get"
			}
		],
		"params": {
			"share": [],
			"private": [
				{
					"name": "page_no",
					"type": "int",
					"required": true,
					"description": "页码。取值范围:大于零的整数; 默认值:1"
				},
				{
					"name": "page_size",
					"type": "int",
					"required": true,
					"description": "每页条数。取值范围:大于零的整数; 默认值:20;最大值:200"
				},
				{
					"name": "start_modified",
					"type": "date",
					"required": true,
					"description": "可选 2000-01-01 00:00:00  起始的修改时间"
				},
				{
					"name": "end_modified",
					"type": "date",
					"required": true,
					"description": "可选 2000-01-01 00:00:00  结束的修改时间"
				}
			]
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "total_results",
				"type": "number",
				"description": "商品总数"
			},
			{
				"name": "has_next",
				"type": "bool",
				"description": "是否有下一页"
			},
			{
				"name": "items",
				"type": "items",
				"description": "返回商品信息（包括商品的sku，图片，规格等）"
			}
		]
	},
	"structure": [
		{
			"name": "imgs",
			"params": [
				{
					"name": "height",
					"type": "number",
					"enumerable": false,
					"description": "图片原始宽度"
				},
				{
					"name": "img_url",
					"type": "string",
					"enumerable": false,
					"description": "图片地址"
				},
				{
					"name": "width",
					"type": "number",
					"enumerable": false,
					"description": "图片原始高度"
				}
			]
		},
		{
			"name": "items",
			"params": [
				{
					"name": "created",
					"type": "datetime",
					"enumerable": false,
					"description": "商品创建时间"
				},
				{
					"name": "idd",
					"type": "string",
					"enumerable": false,
					"description": "商品ID"
				},
				{
					"name": "imgs",
					"type": "imgs",
					"enumerable": false,
					"description": "商品所有的图片"
				},
				{
					"name": "modified",
					"type": "datetime",
					"enumerable": false,
					"description": "商品修改时间"
				},
				{
					"name": "pic_url",
					"type": "string",
					"enumerable": false,
					"description": "商品主图图片地址"
				},
				{
					"name": "price",
					"type": "number",
					"enumerable": false,
					"description": "商品的价格"
				},
				{
					"name": "props",
					"type": "props",
					"enumerable": false,
					"description": "商品所有的规则"
				},
				{
					"name": "quantity",
					"type": "number",
					"enumerable": false,
					"description": "当quantity_setting设置为1时，此字段为库存数"
				},
				{
					"name": "quantity_setting",
					"type": "number",
					"enumerable": false,
					"description": "商品是否设置库存（0为不设，1为设置库存）"
				},
				{
					"name": "sell_count",
					"type": "number",
					"enumerable": false,
					"description": "已售商品数量"
				},
				{
					"name": "skus",
					"type": "skus",
					"enumerable": false,
					"description": "商品所有的sku"
				},
				{
					"name": "title",
					"type": "string",
					"enumerable": false,
					"description": "商品标题"
				}
			]
		},
		{
			"name": "props",
			"params": [
				{
					"name": "code",
					"type": "string",
					"enumerable": false,
					"description": "规格标示"
				},
				{
					"name": "name",
					"type": "string",
					"enumerable": false,
					"description": "规格名称"
				},
				{
					"name": "option_id",
					"type": "number",
					"enumerable": false,
					"description": "规格ID"
				},
				{
					"name": "position",
					"type": "string",
					"enumerable": false,
					"description": "用于sku规格内容的字段名（position＝0对应sku中的字段名option1 以此类推，现有只支持到4种规格）"
				}
			]
		},
		{
			"name": "skus",
			"params": [
				{
					"name": "created",
					"type": "datetime",
					"enumerable": false,
					"description": "sku的创建时间"
				},
				{
					"name": "modified",
					"type": "datetime",
					"enumerable": false,
					"description": "sku的修改时间"
				},
				{
					"name": "option1",
					"type": "string",
					"enumerable": false,
					"description": "规格1的值，规格的名字对应props中position等于0的纪录"
				},
				{
					"name": "option2",
					"type": "string",
					"enumerable": false,
					"description": "规格2的值，规格的名字对应props中position等于1的纪录"
				},
				{
					"name": "option3",
					"type": "string",
					"enumerable": false,
					"description": "规格3的值，规格的名字对应props中position等于2的纪录"
				},
				{
					"name": "option4",
					"type": "string",
					"enumerable": false,
					"description": "规格4的值，规格的名字对应props中position等于3的纪录"
				},
				{
					"name": "price",
					"type": "number",
					"enumerable": false,
					"description": "sku价格"
				},
				{
					"name": "quantity",
					"type": "number",
					"enumerable": false,
					"description": "当quantity_setting设置为1时，此字段为库存数"
				},
				{
					"name": "quantity_setting",
					"type": "number",
					"enumerable": false,
					"description": "商品是否设置库存（0为不设，1为设置库存）"
				},
				{
					"name": "sku_code",
					"type": "string",
					"enumerable": false,
					"description": "sku 外部标示"
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "sku  ID"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.items.onsale.get.json
 ** module id = 526
 ** module chunks = 1
 **/